import { createSlice } from "@reduxjs/toolkit";
import {
  fetchBlocks,
  fetchBlockById,
  updateBlock,
  updateStatusInBlock,
} from "./thunk";

interface BlockState {
  blockList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedBlock: any;
}

const initialState: BlockState = {
  blockList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedBlock: null,
};

const blockSlice = createSlice({
  name: "block",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBlocks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlocks.fulfilled, (state, action) => {
        state.loading = false;
        state.blockList = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchBlocks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch blocks";
      })
      .addCase(fetchBlockById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBlockById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedBlock = action.payload;
      })
      .addCase(fetchBlockById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(updateBlock.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.blockList = state.blockList.map((blk) =>
          blk.id === action.payload.id ? action.payload : blk
        );
      })
      .addCase(updateBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update block";
      })
      .addCase(updateStatusInBlock.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        // state.blockList = state.blockList.map((blk) =>
        //   blk.id === action.payload.id ? action.payload : blk
        // );
        // return action.payload
      })
      .addCase(updateStatusInBlock.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update status";
      });
  },
});

export default blockSlice.reducer;
